import { fetch } from '@utils/utils';

export const getGeneralSettings = ({ addError }) => async (): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/settings/general`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    const json: any = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const postGeneralSettings = async ({ id, ...data }: any): Promise<any> => {
  const body = { id: '038605bb-e9ec-4181-91c2-4fa3fa732b71', ...data };
  try {
    const response: any = await fetch(`/metropolis/api/settings/general`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    const result = await response.json();
    return result;
  } catch (err) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/generalSettings/_generalSettingsActions.ts